import { useEffect } from 'react'
import { applyHighlights, countWordsAndGetExcess } from './codemirror.helper'
import { isNil } from 'lodash'

export const useHighlights = (editorInstance, highlightRanges) => {
    useEffect(() => {
        if (editorInstance.current) {
            applyHighlights(editorInstance.current, highlightRanges)
        }
    }, [highlightRanges, editorInstance])
}

export const useExcessWordsHighlights = (editorInstance, value, wordsLimit) => {
    useEffect(() => {
        if (editorInstance.current) {
            const highlightExcessWords = (editor, text, wordsLimit) => {
                if (isNil(wordsLimit)) return
                const { excessStart } = countWordsAndGetExcess(text, wordsLimit)
                if (excessStart !== null) {
                    editor.getAllMarks().forEach(mark => (mark.className === 'excess-content' ? mark.clear() : null)) // Clear previous excess word marks
                    editor.markText(
                        // Mark excess word
                        editor.posFromIndex(excessStart),
                        { line: editor.lastLine() },
                        { className: 'excess-content' },
                    )
                }
            }

            highlightExcessWords(editorInstance.current, value, wordsLimit)
        }
    }, [editorInstance, wordsLimit, value])
}
